module.exports = __webpack_public_path__ + "static/media/lalashan_package.eb976c11.webp";